import { useState } from 'react';
import {
    Container,
    Grid,
    TextField,
    Typography,
    Button
} from '@mui/material';

export default function Importante() {
    const [respuesta, setRespuesta] = useState('');
    const [correcto, setCorrecto] = useState(false);
    const [mensaje, setMensaje] = useState('');

    const validarRespuesta = () => {
        if (respuesta.trim().toLowerCase() === 'el siguiente. siempre el siguiente paso') {
            setCorrecto(true);
        } else {
            setMensaje('Respuesta incorrecta');
        }
    };

    return (
        <Container
            sx={{
                mt: 5,
                mb: 4,
                border: '1px solid #517ED3',
                borderRadius: '5px',
                p: 3,
                textAlign: 'center'
            }}
        >
            {!correcto ? (
                <Grid container spacing={2} direction="column">
                    <Grid>
                        <Typography variant="h6">
                            ¿Cuál es el paso más importante que puede dar un hombre?
                        </Typography>
                    </Grid>
                    <br />
                    <Grid>
                        <TextField
                            label="Respuesta"
                            value={respuesta}
                            onChange={(e) => setRespuesta(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <br />
                    <Grid>
                        <Button
                            variant="contained"
                            onClick={validarRespuesta}
                        >
                            Verificar
                        </Button>
                    </Grid>
                    <br />
                    {mensaje && (
                        <Grid>
                            <Typography color="error">
                                {mensaje}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            ) : (
                <>
                    <Typography variant="h4" gutterBottom>
                        Estas palabras son aceptadas
                    </Typography>

                    <Typography sx={{ mt: 2 }}>
                        Vida antes que muerte.
                    </Typography>

                    <Typography sx={{ mt: 2 }}>
                        Fuerza antes que debilidad.
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                        Viaje antes que destino.
                    </Typography>
                </>
            )}
        </Container>
    );
}